// planReward (TECH_BASELINE §6.3): kế hoạch thuần của một lần trao thưởng. Lớp state áp kế hoạch
// này trong một batch(); sim không tự trao gì.
import type { ItemInstance } from '@data/items/types';

export type Reward =
  | { kind: 'currency'; id: string; amount: number }
  /** Vật phẩm xếp chồng theo khóa chồng (`herb.x@century`, `pill.x#mid`, `mat.x`). */
  | { kind: 'goods'; key: string; amount: number }
  | { kind: 'item'; item: ItemInstance };

export interface RewardPlan {
  currency: Record<string, number>;
  goods: Record<string, number>;
  items: ItemInstance[];
}

export function planReward(rewards: readonly Reward[]): RewardPlan {
  const currency: Record<string, number> = {};
  const goods: Record<string, number> = {};
  const items: ItemInstance[] = [];
  for (const r of rewards) {
    if (r.kind === 'item') {
      items.push(r.item);
      continue;
    }
    if (!(r.amount > 0) || !Number.isFinite(r.amount)) continue;
    const into = r.kind === 'currency' ? currency : goods;
    const id = r.kind === 'currency' ? r.id : r.key;
    into[id] = (into[id] ?? 0) + Math.floor(r.amount);
  }
  return { currency, goods, items };
}
